import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { RoutePaths } from "src/app/model";
import { useLocale } from "src/shared/i18n";

export const Logo: React.FC = () => {
  const navigate = useNavigate();
  const { toRoute } = useLocale();

  return (
    <Typography
      variant="h4"
      component="p"
      color="primary"
      onClick={() => {
        navigate(toRoute(RoutePaths.HOME));
        window.scrollTo(0, 0);
      }}
      sx={{
        textShadow: "1px 1px 20px rgba(166,228,176,1);",
        order: { md: "initial", xs: "1" },
        flexGrow: { md: 0, xs: 1 },
        textAlign: { md: "start", xs: "center" },
        cursor: "pointer",
      }}
    >
      SB
    </Typography>
  );
};
